<script setup>
defineExpose({
  name: 'Impressao',
})
</script>

<template>
  <NuxtPage />
</template>
